import React from 'react'
import { Tr } from '../../../../_metronic/i18n/Tr'

interface CompleteSteps {
  placement?: boolean
  target?: boolean
  banner?: boolean
  adsDetails?: boolean
  payment?: boolean
}

interface AddAdvertisementHeaderProps {
  advertisementId?: string
  activeTab: number
  onTabChange: (index: number) => void
  completeSteps?: CompleteSteps | null
}

const TAB_STEP_KEYS: (keyof CompleteSteps)[] = ['placement', 'target', 'banner', 'adsDetails', 'payment']

const AddAdvertisementHeader: React.FC<AddAdvertisementHeaderProps> = ({
  activeTab,
  onTabChange,
  completeSteps,
}) => {
  const t = Tr()

  const tabs = [
    { label: t('Placement'), index: 0 },
    { label: t('Targeting'), index: 1 },
    { label: t('Banner'), index: 2 },
    { label: t('Ads Detail'), index: 3 },
    { label: t('Budget & Payment'), index: 4 },
  ]

  // Find the max accessible tab index:
  // All completed tabs + one step ahead are accessible.
  const getMaxAccessibleTab = (): number => {
    if (!completeSteps) return 0
    for (let i = 0; i < TAB_STEP_KEYS.length; i++) {
      if (!completeSteps[TAB_STEP_KEYS[i]]) return i
    }
    return TAB_STEP_KEYS.length - 1
  }

  const maxAccessibleTab = getMaxAccessibleTab()

  const isTabAccessible = (index: number) => index <= maxAccessibleTab
  const isTabCompleted = (index: number) => !!completeSteps?.[TAB_STEP_KEYS[index]]

  const getTabClassName = (index: number) => {
    const base = 'nav-link me-6 p-3 text-nowrap'
    if (activeTab === index) return `${base} active bg-primary text-white rounded`
    if (isTabCompleted(index)) return `${base} bg-success text-white rounded cursor-pointer`
    if (isTabAccessible(index)) return `${base} bg-transparent cursor-pointer`
    return `${base} bg-transparent text-muted`
  }

  return (
    <div className='card mb-5 mb-xl-10 mt-3'>
      <div className='card-body'>
        <div className='d-flex overflow-auto'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
            {tabs.map((tab) => (
              <li className='nav-item' key={tab.index}>
                <button
                  type='button'
                  className={getTabClassName(tab.index)}
                  onClick={() => {
                    if (isTabAccessible(tab.index)) {
                      onTabChange(tab.index)
                      sessionStorage.setItem('indexTabAd', tab.index.toString())
                    }
                  }}
                  disabled={!isTabAccessible(tab.index)}
                  role='tab'
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export { AddAdvertisementHeader }

